var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-platform-design",attrs:{"id":"app"},on:{"click":_vm.playClickIfAllowed}},[(_vm.blocked)?void 0:[(_vm.isBannerVisible)?_c('AllowNotificationsBanner',{on:{"remind":_vm.allowRemind,"close":_vm.closeBanner}}):_vm._e(),_c('NewDesign')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }